import { useEffect, useState } from 'react';
import { CONFIG } from '../config/config';

export function readEarlyAccessRecord() {
  try {
    const raw = localStorage.getItem(CONFIG.STORAGE.EARLY_ACCESS);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

export function hasEarlyAccess() {
  const rec = readEarlyAccessRecord();
  return Boolean(rec && rec.early_access === true);
}

export function saveEarlyAccess({ email, phone }) {
  const payload = {
    email: String(email || '').trim(),
    phone: String(phone || '').trim(),
    early_access: true,
  };
  localStorage.setItem(CONFIG.STORAGE.EARLY_ACCESS, JSON.stringify(payload));
  window.dispatchEvent(new Event('earlyAccessUpdated'));
  return payload;
}

/** Re-render consumers when early access is saved (same tab). */
export function useEarlyAccessListener() {
  const [, setRev] = useState(0);
  useEffect(() => {
    const fn = () => setRev((r) => r + 1);
    window.addEventListener('earlyAccessUpdated', fn);
    return () => window.removeEventListener('earlyAccessUpdated', fn);
  }, []);
}
